<template>
  <v-list-item
    @click.stop="clickItem"
    three-line
    :class="!item.isReaded ? 'unread' : ''"
  >
    <v-list-item-avatar>
      <avatarBody
        :photoUrl="item.photoUrl"
        :name="item.nickname"
      ></avatarBody>
    </v-list-item-avatar>
    <v-list-item-content>
      <v-list-item-title>{{ item.nickname }}</v-list-item-title>
      <v-list-item-subtitle style="font-weight:normal">{{ item.latestComment }}</v-list-item-subtitle>
    </v-list-item-content>
    <v-list-item-action>
      <v-list-item-action-text>
        <elapsedTime
          :dateTime="item.modified"
        ></elapsedTime> ago
      </v-list-item-action-text>
    </v-list-item-action>
  </v-list-item>
</template>

<script>
import ElapsedTime from '@/components/ElapsedTime'
import AvatarBody from '@/components/Like/AvatarBody'

export default {
  components: {
    AvatarBody,
    ElapsedTime,
  },
  props: {
    item: { type: Object, require: true, },
  },
  methods: {
    clickItem() {
      this.$emit('click', this.item)
    },
    lpad(n) {
      if (n > 9) {
        return n
      }
      return `0${n}`
    },
  },
};
</script>

<style lang="stylus" scoped>
.unread
  background-color rgba(255, 85, 0, 0.1)
</style>